import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function BtnAdd({ onBtnClick, forDisable, masterAddEditAccess, addEditAccess, isProductArchived }) {
  const { t } = useTranslation('common');

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('APPROVE_REJECTS.ADD')}
    </Tooltip>
  );
  return masterAddEditAccess || addEditAccess ? (
    <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip}>
      <button type="button" onClick={onBtnClick} className="filter-btn filter-button_add" disabled={(forDisable, isProductArchived)}>
        <span className="text-icon">{t('APPROVE_REJECTS.ADD')}</span>
        <i className="icon-add f-24" />
      </button>
    </OverlayTrigger>
  ) : null;
}

export default BtnAdd;
